import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { FC } from 'react';
import noBooking from '../../images/noBooking.svg';
import { isMobile } from '../../utils/common';

const NoBooking: FC = () => {
    const isMob = isMobile();

    return (
        <div
            className={clsx(
                'flex flex-col p-20',
                isMob ? 'gap-10 bg-white' : 'gap-20 justify-center items-center h-fit rounded-20 shadow-100',
            )}
        >
            {!isMob && <img src={noBooking} width={160} height={160} alt='No booking' loading='lazy' />}
            <Typography variant={isMob ? 'h4' : 'h5'} fontWeight='medium' className={clsx(!isMob && 'text-center')}>
                You do not have any bookings yet!
            </Typography>
        </div>
    );
};

export default NoBooking;
